/**
 * Establecer las Indicaciones de peligro asociadas al producto.
 * 
 * @param Object state
 * @param Array nextState
 */
export function setDangerIndications(state, nextState) {
    state.dangerIndications = nextState
}

/**
 * Establecer las Indicaciones de peligro asociadas al producto en formato para las etiquetas.
 * 
 * @param Object state
 * @param Array nextState
 */
export function setDangerIndicationsHtml(state, nextState) {
    state.dangerIndicationsHtml = nextState
}
